const state = {
    sm_warehouses: [],
    sm_warehouse: {},
}

export default state;
